var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dialog_center" }, [
    _vm._m(0),
    _vm._v(" "),
    (_vm.productType == "2" || _vm.productType == "4"
    ? true
    : false)
      ? _c(
          "div",
          { staticClass: "device_detail" },
          [
            _c("div", [
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#e89e41",
                    "font-size": "20px",
                    "text-align": "center",
                    "font-weight": "bold",
                    "line-height": "45px"
                  }
                },
                [_vm._v(_vm._s(_vm.dialog_data.alarmType))]
              )
            ]),
            _vm._v(" "),
            _c("deviceList", { attrs: { deviceDataList: _vm.device_data } })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    (_vm.productType == "1"
    ? true
    : false)
      ? _c("div", { staticClass: "civilian_device_detail" }, [
          _c(
            "div",
            { staticClass: "pics_group" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 4 } },
                _vm._l(_vm.dialogData.infodata.pic, function(item, index) {
                  return _c(
                    "el-col",
                    {
                      key: index,
                      staticClass: "grid-content bg-purple",
                      attrs: { span: 8 }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { position: "relative", height: "200px" }
                        },
                        [
                          _c("el-image", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: {
                              fit: "cover",
                              src: item.url,
                              "preview-src-list": _vm.srcList
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "item_span_type" }, [
                            _vm._v(_vm._s(item.name))
                          ])
                        ],
                        1
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "civilian_alarmMes" }, [
            _c("span", [_vm._v(_vm._s(_vm.dialogData.alarminfo.alarmName))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.dialogData.alarminfo.time))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    (_vm.productType == "3"
    ? true
    : false)
      ? _c("div", { staticClass: "civilian_device_detail" }, [
          _c(
            "div",
            { staticClass: "pics_group" },
            [
              _c(
                "el-carousel",
                { attrs: { interval: 4000, arrow: "always" } },
                _vm._l(_vm.dialogData.infodata.pic, function(item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: item.name + index },
                    [
                      _c(
                        "h4",
                        {
                          staticStyle: {
                            color: "#909399",
                            position: "absolute"
                          }
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-image",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            src: item.url,
                            "preview-src-list": _vm.srcList
                          }
                        },
                        [_vm._v(">")]
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "industrial_alarmMes" }, [
            _c("span", [_vm._v(_vm._s(_vm.dialogData.alarminfo.alarmName))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.dialogData.alarminfo.time))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "qiehuan" },
      [
        _c(
          "el-link",
          {
            staticStyle: { color: "skyblue" },
            attrs: { icon: "el-icon-user-solid" },
            on: {
              click: function($event) {
                return _vm.qiehuanClick(0)
              }
            }
          },
          [_vm._v("基础信息")]
        ),
        _vm._v(" "),
        _c(
          "el-link",
          {
            staticStyle: { color: "skyblue" },
            on: {
              click: function($event) {
                return _vm.qiehuanClick(1)
              }
            }
          },
          [_c("i", { staticClass: "el-icon-sunrise-1" }), _vm._v("配件信息")]
        ),
        _vm._v(" "),
        _c(
          "el-link",
          {
            staticStyle: { color: "skyblue" },
            on: {
              click: function($event) {
                return _vm.qiehuanClick(2)
              }
            }
          },
          [_c("i", { staticClass: "el-icon-position" }), _vm._v("地理位置 ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content_detail" }, [
      _c(
        "div",
        { staticClass: "detai_box" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _vm._l(_vm.dialogData.infodata.info, function(item, index) {
                return _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.lodeg_isbool,
                        expression: "lodeg_isbool"
                      }
                    ],
                    key: item.key + item.value,
                    attrs: { span: 10 }
                  },
                  [
                    _c("span", { staticClass: "dian" }),
                    _vm._v(_vm._s(item.key) + "：" + _vm._s(item.value))
                  ]
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.dialogData.infodata.peri, function(item, index) {
                return _c(
                  "el-col",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.lodeg_isbool,
                        expression: "!lodeg_isbool"
                      }
                    ],
                    key: item.key + item.value,
                    attrs: { span: 10 }
                  },
                  [
                    _c("span", { staticClass: "dian" }),
                    _vm._v(_vm._s(item.key) + "：" + _vm._s(item.value))
                  ]
                )
              })
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message_bar" }, [
      _c("span", [
        _c("img", {
          attrs: {
            src:
              "https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/icon/message.png"
          }
        }),
        _vm._v("\n            消息：已发送\n        ")
      ]),
      _vm._v(" "),
      _c("span", [
        _c("img", {
          attrs: {
            src:
              "https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/icon/news.png"
          }
        }),
        _vm._v("\n            短信：已发送\n\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a086c35", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a086c35","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialog_center.vue
// module id = null
// module chunks = 